import React from 'react';

// Zeitebenen fuer Charts (Detail-Panel im Live-Modul UND Charts-Modul) - 1T/1W
// ueber Intraday-Kerzen (Zeit-Achse), 1M/6M/1J/5J ueber Tages-Kerzen
// (Datums-Achse, siehe MarketdataChart.inc/MarketdataCharts.inc). Live
// getestet bereits im Premium-Plan bis 1990 zurueck verfuegbar (siehe
// [[project_marketdata_realtime_module]]) - kein Ultimate-Upgrade noetig.
export const CHART_RANGES = [
	{ code: '1T', label: '1 Tag', intraday: true },
	{ code: '1W', label: '1 Woche', intraday: true },
	{ code: '1M', label: '1 Monat', intraday: false },
	{ code: '6M', label: '6 Monate', intraday: false },
	{ code: '1J', label: '1 Jahr', intraday: false },
	{ code: '5J', label: '5 Jahre', intraday: false },
];

// Uhr-Icon + Dropdown zur Auswahl der Zeitebene - eigene Komponente, damit
// Detail-Panel (Live-Modul) und Charts-Modul dieselbe Auswahl/Optik nutzen,
// ohne sie zu duplizieren.
export default function MarketdataRangeSelector({ range, onChange, title }) {
	const [showMenu, setShowMenu] = React.useState(false);
	const menuRef = React.useRef(null);

	React.useEffect(() => {
		if (!showMenu) {
			return;
		}
		function handleClickOutside(e) {
			if (menuRef.current && !menuRef.current.contains(e.target)) {
				setShowMenu(false);
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [showMenu]);

	return (
		<span className="marketdata-chart-range-selector" ref={menuRef}>
			<i
				className="bi bi-clock-history module-icon"
				title={title || 'Zeitebene wählen'}
				onClick={() => setShowMenu((current) => !current)}
			/>
			{showMenu &&
				<div className="marketdata-chart-range-dropdown">
					{CHART_RANGES.map((r) => (
						<div
							key={r.code}
							className={'marketdata-chart-range-item' + (r.code === range ? ' marketdata-chart-range-item-active' : '')}
							onClick={() => { onChange(r.code); setShowMenu(false); }}
						>
							{r.label}
						</div>
					))}
				</div>
			}
		</span>
	);
}
